import { QueryClient } from "@tanstack/react-query";

import { isApiError } from "@/configs/request";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // 4xx hech qachon qayta so'ralmaydi: 404 va 403 takrorlashdan
        // muvaffaqiyatli bo'lib qolmaydi, faqat xatoni ko'paytiradi.
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
